import { render } from "./PefView.vue?vue&type=template&id=39c809d4"
import script from "./PefView.vue?vue&type=script&lang=js"
export * from "./PefView.vue?vue&type=script&lang=js"

import "./PefView.vue?vue&type=style&index=0&id=39c809d4&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__